/**
 * 客户标签
 * @Description: 客户标签模块路由及完整子路由
 *
 * @Author: JZT.lzw
 * @Date: 2019-02-20 15:47:23
 * @Last Modified by: JZT.lzw
 * @Last Modified time: 2019-02-20 15:47:23
 */
export default [
    {
        path: "/labels/labelMgr",
        name: "标签管理",
        component: () => import("@/pages/labels/labelMgr"),
        icon: "none",
        meta: {
            comName: "labelList",
            needRefresh: true
        }
    },
    // 新建标签
    {
        path: "/labels/labelMgr/add",
        name: "新建标签",
        component: () => import("@/pages/labels/labelMgr/labelAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "labelAdd"
        }
    },
    // 编辑标签
    {
        path: "/labels/labelMgr/edit",
        name: "编辑标签",
        component: () => import("@/pages/labels/labelMgr/labelEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "labelEdit"
        }
    },
    // 客户标签详情
    {
        path: "/labels/labelMgr/customerLabel",
        name: "客户标签详情",
        component: () => import("@/pages/labels/labelMgr/customerLabel"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "custLabelDet"
        }
    },
    // 商品标签详情
    {
        path: "/labels/labelMgr/goodsLabel",
        name: "商品标签详情",
        component: () => import("@/pages/labels/labelMgr/goodsLabel"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "goodsLabelDet"
        }
    },
    // 客户打标签
    {
        path: "/labels/customerLabel",
        name: "客户打标签",
        component: () => import("@/pages/labels/customerLabel"),
        icon: "none",
        meta: {
            comName: "custLabelList",
            needRefresh: true
        }
    },
    // 客户打标签 - 添加
    {
        path: "/labels/customerLabel/add",
        name: "客户打标签-添加",
        component: () => import("@/pages/labels/customerLabel/customerLabelAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "custLabelAdd"
        }
    },
    // 商品打标签
    {
        path: "/labels/goodsLabel",
        name: "商品打标签",
        component: () => import("@/pages/labels/goodsLabel"),
        icon: "none",
        meta: {
            comName: "goodsLabelList",
            needRefresh: true
        }
    },
    // 商品打标签 - 添加
    {
        path: "/labels/goodsLabel/add",
        name: "商品打标签-添加",
        component: () => import("@/pages/labels/goodsLabel/goodsLabelAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "goodsLabelAdd"
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/labels.js